import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { AddressParam } from '@/actions/stripe'

export type Customer = {
  email: string
  name: string
  lastName: string
  phone: string
  dninie: string
  /** Código ISO 3166-2:ES sin prefijo ('M', 'GC', 'TF'). '' = sin elegir. */
  province: string
}

export type CustomerStore = {
  customer: Customer
  address: AddressParam
  setEmail(email: string): void
  setCustomer(customer: Customer): void
  setDninie(dninie: string): void
  setProvince(province: string): void
  setAddress(address: AddressParam): void
  reset(): void
}

const initialState = {
  customer: {
    email: '',
    name: '',
    lastName: '',
    phone: '',
    dninie: '',
    province: '',
  },
  balance: 0,
  subAmount: 0,
  address: {},
}

export const useCustomerStore = create<CustomerStore>()(
  persist(
    (set) => ({
      ...initialState,
      setEmail: (email: string) =>
        set((customer) => ({
          customer: { ...customer.customer, email },
        })),
      setCustomer: (customer: Customer) =>
        set(() => ({
          customer,
        })),
      setDninie: (dninie: string) =>
        set((customer) => ({
          customer: { ...customer.customer, dninie },
        })),
      setProvince: (province: string) =>
        set((customer) => ({
          customer: { ...customer.customer, province },
        })),
      setAddress(address: AddressParam) {
        set((customer) => {
          return {
            ...customer,
            address,
          }
        })
      },
      reset: () => set(initialState),
    }),
    {
      name: 'customer-storage',
      version: 1,
      storage: createJSONStorage(() => localStorage),
      // El merge de zustand es shallow: el `customer` de localStorage sustituye
      // entero al inicial, así que quien tenga una compra a medias de antes de
      // este despliegue se quedaría con `province: undefined`. Aquí se rellena
      // con el estado inicial. No se compara `version` a propósito: los sobres
      // antiguos no la traen (llega `undefined`) y cualquier comparación
      // numérica contra undefined es false.
      migrate: (persistedState: unknown) => {
        const state = (persistedState ?? {}) as Partial<CustomerStore>
        return {
          ...state,
          customer: { ...initialState.customer, ...(state.customer ?? {}) },
        }
      },
    }
  )
)
